import {
  ButtonGroup,
  Grid,
  GridItem,
  PrimaryButton,
  SelectInputField,
} from "@certn/cascadia-react";
import { Field, Form, Formik } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Item } from "react-stately";

import { SettingsEditItem } from "../../../components/Settings/SettingsEditItem";
import { useLanguageOptions } from "../../../hooks/api/useLanguageOptions";
import { useFormSubmit } from "../../../hooks/api/useSubmit";
import { useLanguage } from "../../../hooks/useLanguage";

export function LanguageSettings() {
  const { t, i18n } = useTranslation();
  const { changeLanguage } = useLanguage();
  const [expanded, setExpanded] = useState(false);
  const toggle = () => setExpanded((curr) => !curr);
  const { languageOptions } = useLanguageOptions();
  const { currentLanguageLabel } = useLanguage();

  const handleSubmit = useFormSubmit("/internal/people/me/language/update/", {
    onSuccess: (values) => {
      toggle();
      changeLanguage(values.language);
    },
  });

  return (
    <SettingsEditItem
      setting={t("Language")}
      value={currentLanguageLabel ?? "-"}
      description={t(
        "This will change the language settings within your profile. Don’t see your preferred language? Let us know here."
      )}
      expanded={expanded}
      toggle={toggle}
      testID={
        expanded
          ? "language-preference-cancel-link"
          : "language-preference-edit-link"
      }
    >
      <Formik
        initialValues={{ language: i18n.resolvedLanguage ?? i18n.language }}
        onSubmit={handleSubmit}
      >
        <Form>
          <Grid width="416px">
            <GridItem>
              <Field
                name="language"
                as={SelectInputField}
                isRequired
                aria-label={t("Language")}
              >
                {languageOptions?.map((language) => (
                  <Item key={language.value}>{language.display_value}</Item>
                ))}
              </Field>
            </GridItem>
            <GridItem>
              <ButtonGroup>
                <PrimaryButton
                  type="submit"
                  size="medium"
                  testID="language-preference-save-button"
                >
                  {t("Save")}
                </PrimaryButton>
              </ButtonGroup>
            </GridItem>
          </Grid>
        </Form>
      </Formik>
    </SettingsEditItem>
  );
}
